import React from "react";
import Slider from "react-slick";
import { motion } from "framer-motion";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useTranslation } from "react-i18next";
import "slick-carousel/slick/slick.css";
import "../index.css"; // Or your global CSS where tailwind and slick customizations are added

const images = [
  "/assets/gallery/gallery1.jpg",
  "/assets/gallery/gallery2.jpg",
  "/assets/gallery/gallery3.jpeg",
  "/assets/gallery/gallery4.jpeg",
  "/assets/gallery/gallery5.jpeg",
];

const GallerySlider = () => {
  const { t } = useTranslation();

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 1024,
        settings: { slidesToShow: 2 },
      },
      {
        breakpoint: 768,
        settings: { slidesToShow: 1 },
      },
    ],
  };

  return (
    <section id="gallery" className="py-20 bg-gray-100 px-4">
      <div className="max-w-6xl mx-auto text-center">
        <motion.h2
          className="text-3xl md:text-4xl font-bold text-purple-700 mb-8"
          initial={{ opacity: 0, y: -20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
                  {t("gallery.title")}

        </motion.h2>

        <Slider {...settings}>
          {images.map((img, index) => (
            <motion.div
              key={index}
              className="px-3"
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              transition={{ delay: 0.2 }}
            >
              <div className="overflow-hidden rounded-lg shadow-lg">
                <img
                  src={img}
                  alt={`Gallery ${index + 1}`}
                  className="w-full h-64 object-cover hover:scale-105 transition duration-300"
                />
              </div>
            </motion.div>
          ))}
        </Slider>
      </div>
    </section>
  );
};

export default GallerySlider;
